import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/login/auth.service';
import { ALL_STORAGE_KEYS } from '../config/client.config';

@Injectable()
export class TokenRefreshInterceptor implements HttpInterceptor {

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse) {
          // Gestione errori di autenticazione (solo 401 Unauthorized)
          // 403 Forbidden viene propagato al componente per mostrare l'errore
          if (error.status === 401) {
            return this.handleSessionExpired();
          }
        }
        return throwError(() => error);
      })
    );
  }

  /**
   * Gestisce la sessione scaduta: pulisce i dati e reindirizza al login
   */
  private handleSessionExpired(): Observable<never> {
    this.auth.logout();

    this.clearCachedData();

    console.warn('Sessione scaduta. Redirect al login.');
    this.router.navigate(['/login'], {
      replaceUrl: true,
      queryParams: { sessionExpired: 'true' }
    });

    return EMPTY;
  }

  /**
   * Pulisce i dati cached dell'applicazione
   */
  private clearCachedData(): void {
    // Chiavi derivate dal prefisso cliente in src/client.config.json:
    // aggiungerne una a STORAGE_KEYS la fa ripulire automaticamente anche qui.
    ALL_STORAGE_KEYS.forEach(key => {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        // Ignora errori di localStorage
      }
    });
  }
}
